var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 209.24 154.88" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "a", transform: "translate(-151.13 -119)" },
        React.createElement("path", { fill: "none", d: "M0 0h500v500H0z" })
      )
    ),
    React.createElement(
      "title",
      null,
      "Drawing ToolTip Vert Strips"
    ),
    React.createElement("path", { fill: "none", stroke: "#969696", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.051", d: "M77.73 10.39h53.78v143.96H77.73z" }),
    React.createElement("path", { fill: "none", stroke: "#338daa", strokeWidth: "2.6", d: "M141.26 9.87v144.39" }),
    React.createElement("path", { d: "M3.13 2.91h203.1v2.25H3.13z" }),
    React.createElement("path", { d: "M6.25 0h1.94v8.06H6.25z" }),
    React.createElement(
      "g",
      { clipPath: "url(#a)" },
      React.createElement("path", { d: "M6.12 4A3.06 3.06 0 1 1 3.06.94 3.06 3.06 0 0 1 6.12 4" })
    ),
    React.createElement("path", { d: "M201.39 0h1.93v8.06h-1.93z" }),
    React.createElement(
      "g",
      { clipPath: "url(#a)" },
      React.createElement("path", { d: "M209.24 4a3.06 3.06 0 1 1-3.06-3.06A3.06 3.06 0 0 1 209.24 4" })
    ),
    React.createElement("path", { fill: "none", stroke: "#ef59a0", strokeWidth: ".975", strokeDasharray: "2.9260001182556152,1.9509999752044678", d: "M66.07 9.87v144.39" }),
    React.createElement("path", { fill: "none", stroke: "#ef59a0", strokeWidth: ".975", strokeDasharray: "2.9100000858306885,1.934999942779541", d: "M81.12 10.83v143.43" }),
    React.createElement("path", { fill: "none", stroke: "#ef59a0", strokeWidth: ".975", strokeDasharray: "2.9030001163482666,1.9279999732971191", d: "M143.05 10.83v143" }),
    React.createElement("path", { fill: "none", stroke: "#338daa", strokeWidth: "2.6", d: "M130.28 9.87v144.39M67.86 9.87v144.39M79.33 9.87v144.39" }),
    React.createElement("path", { fill: "none", stroke: "#ef59a0", strokeWidth: ".975", strokeDasharray: "2.9260001182556152,1.9509999752044678", d: "M128.58 9.87v144.39" }),
    React.createElement("path", { fill: "none", stroke: "#969696", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.051", d: "M15.97 10.39h53.78v143.96H15.97zM139.49 10.39h53.78v143.96h-53.78z" }),
    React.createElement("path", { fill: "#ef59a0", d: "M58.82 78.58h.81v-5.11h-1.46v.73h.65v4.38z" }),
    React.createElement(
      "g",
      { clipPath: "url(#a)", fill: "#ef59a0" },
      React.createElement("path", { d: "M85.8 78.51h3.4v-.67h-2.22c.82-.75 2.08-1.69 2.08-2.93a1.47 1.47 0 0 0-1.63-1.54 1.55 1.55 0 0 0-1.64 1.64h.77c0-.57.32-1 .88-1s.83.36.83.89c0 1-1.27 1.93-2.47 3zM121.11 74.73h.76a.79.79 0 0 1 .86-.69c.55 0 .84.29.84.73s-.44.76-1.16.77h-.19v.66h.18c.83 0 1.27.23 1.27.9a.81.81 0 0 1-.89.84.9.9 0 0 1-1-.84h-.77a1.57 1.57 0 0 0 1.76 1.5c1.07 0 1.64-.61 1.64-1.42a1.24 1.24 0 0 0-.87-1.31 1.19 1.19 0 0 0 .78-1.16c0-.74-.55-1.33-1.57-1.33a1.5 1.5 0 0 0-1.67 1.38" })
    ),
    React.createElement("path", { d: "M148.29 76.82l1.66-2.47v2.47zm1.62 1.76h.79v-1.07h.65v-.69h-.65v-3.28h-1l-2.35 3.37v.6h2.52z", fill: "#ef59a0" })
  );
});